import { render, staticRenderFns } from "./TimerRedirect.vue?vue&type=template&id=35fb355b&scoped=true"
import script from "./TimerRedirect.vue?vue&type=script&lang=ts"
export * from "./TimerRedirect.vue?vue&type=script&lang=ts"
import style0 from "./TimerRedirect.vue?vue&type=style&index=0&id=35fb355b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb355b",
  null
  
)

export default component.exports